// As of version 2, Baobab doesn't deal well with having non-data
// (e.g. a reference to an inline text editor) stored in it. So we 
// need somewhere else to hold stuff. I don't want to go all out and
// create Flux stores, but I also don't want to just start setting things
// on the window (or the node.js global object). So this exists to be 
// explicit about when stuff is being stored globally.
module.exports = new Map();
